module.exports = __webpack_public_path__ + "static/img/logo_small.f6750ee5.png";